const easy = [
  { id: 1, name: "motion", image: "./assets/images/motion.png" },
  { id: 2, name: "motion", image: "./assets/images/motion.png" },
  { id: 3, name: "motionPlus", image: "./assets/images/motionPlus.png" },
  { id: 4, name: "motionPlus", image: "./assets/images/motionPlus.png" },
  { id: 5, name: "blocks", image: "./assets/images/blocks.png" },
  { id: 6, name: "blocks", image: "./assets/images/blocks.png" },
  { id: 7, name: "mind", image: "./assets/images/mind.png" },
  { id: 8, name: "mind", image: "./assets/images/mind.png" },
  { id: 9, name: "chicken", image: "./assets/images/chicken.png" },
  { id: 10, name: "chicken", image: "./assets/images/chicken.png" },
  { id: 11, name: "denta", image: "./assets/images/denta.png" },
  { id: 12, name: "denta", image: "./assets/images/denta.png" },
  { id: 13, name: "energy", image: "./assets/images/energy.png" },
  { id: 14, name: "energy", image: "./assets/images/energy.png" },
  { id: 15, name: "eukanuba", image: "./assets/images/eukanuba.png" },
  { id: 16, name: "eukanuba", image: "./assets/images/eukanuba.png" },
  { id: 17, name: "gut", image: "./assets/images/gut.png" },
  { id: 18, name: "gut", image: "./assets/images/gut.png" },
  { id: 19, name: "immunity", image: "./assets/images/immunity.png" },
  { id: 20, name: "immunity", image: "./assets/images/immunity.png" }
];

const complex = [
  { id: 1, name: "motion", image: "./assets/images/motion.png" },
  { id: 2, name: "motion", image: "./assets/images/motion.png" },
  { id: 3, name: "motionPlus", image: "./assets/images/motionPlus.png" },
  { id: 4, name: "motionPlus", image: "./assets/images/motionPlus.png" },
  { id: 5, name: "blocks", image: "./assets/images/blocks.png" },
  { id: 6, name: "blocks", image: "./assets/images/blocks.png" },
  { id: 7, name: "mind", image: "./assets/images/mind.png" },
  { id: 8, name: "mind", image: "./assets/images/mind.png" },
  { id: 9, name: "chicken", image: "./assets/images/chicken.png" },
  { id: 10, name: "chicken", image: "./assets/images/chicken.png" },
  { id: 11, name: "denta", image: "./assets/images/denta.png" },
  { id: 12, name: "denta", image: "./assets/images/denta.png" },
  { id: 13, name: "energy", image: "./assets/images/energy.png" },
  { id: 14, name: "energy", image: "./assets/images/energy.png" },
  { id: 15, name: "eukanuba", image: "./assets/images/eukanuba.png" },
  { id: 16, name: "eukanuba", image: "./assets/images/eukanuba.png" },
  { id: 17, name: "gut", image: "./assets/images/gut.png" },
  { id: 18, name: "gut", image: "./assets/images/gut.png" },
  { id: 19, name: "immunity", image: "./assets/images/immunity.png" },
  { id: 20, name: "immunity", image: "./assets/images/immunity.png" }
];

export const easyData = easy.map((easy) => ({
  ...easy,
  order: easy.id,
//  order: Math.floor(Math.random() * 20),
  isFlipped: false,
}));

export const complexData = complex.map((complex) => ({
  ...complex,
  order: complex.id,
//  order: Math.floor(Math.random() * 20),
  isFlipped: false,
}));